import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from 'src/app/layout/pages/page-not-found/page-not-found.component';

import { invoicesRoutes } from './invoices/invoices-routing.module'
import { BatchExportSmartComponent } from './batch-export/batch-export-smart.component';
import { CreateBatchComponent } from './batch-export/create-batch/create-batch.component';

import { RealTimeTransactionsSmartComponent } from './real-time-transactions/real-time-transactions-smart.component';
import { CommisionSmartComponent } from './commision/commision-smart.component';
import { SalesSummarySmartComponent } from './sales-summary/sales-summary-smart.component';
import { RetailerAcquisitionSmartComponent } from './retailer-acquisition/retailer-acquisition-smart.component';
import { LoyaltyReportSmartComponent } from './loyalty-report/loyalty-report-smart.component';

import { PaymentReportSmartComponent } from './payment-report/payment-report-smart.component';

import { RefundSmartComponent } from './refund/refund-smart.component';
import { UserGuard } from 'src/app/framework/crosscutting/authorization/user.guard';
import { TransactionSummarySmartComponent } from './transaction-summary/transaction-summary-smart.component';

export const reportsRoutes: Routes = [
  {
    path: 'invoices', children: [...invoicesRoutes], 
  },
  {
    path: 'payment-report', component: PaymentReportSmartComponent, 
  },
  {
    path: 'batch-export', component: BatchExportSmartComponent
  },
  {
    path: 'batch-export/create-batch', component: CreateBatchComponent
  },
  {
    path: 'real-time-transactions', component: RealTimeTransactionsSmartComponent, canActivate : [UserGuard]
  },
  {
    path: 'commision', component: CommisionSmartComponent
  },
  {
    path: 'sales-summary', component: SalesSummarySmartComponent
  },
  {
    path: 'transaction-summary', component: TransactionSummarySmartComponent
  },
  {
    path: 'retailer-acquisition', component: RetailerAcquisitionSmartComponent
  },
  {
    path: 'loyalty-report', component: LoyaltyReportSmartComponent
  },
  {
    path: 'refund-report', component: RefundSmartComponent
  },
  { 
    path: '', component: RealTimeTransactionsSmartComponent,
  },
  {
    path: '**', component: PageNotFoundComponent
  }

];

@NgModule({
  imports: [RouterModule.forChild(reportsRoutes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
